import styled from 'styled-components/macro';

import CB from 'commons/Checkbox';

export const Container = styled.div``;

export const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;

  @media only screen and (min-width: ${({ theme: { breakpoints } }) =>
      breakpoints.tablet}) {
    justify-content: flex-start;
  }
`;

export const Checkbox = styled(CB)`
  display: inline-block;

  /* Customize the label (the container) */
  label {
    display: inline-flex;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    min-width: 104px;
    width: max-content;
    max-width: 100%;
    height: 44px;
    margin-bottom: 0;
    margin-right: 0;
    border-radius: 22px;
    line-height: 44px;
    text-align: center;

    /* On mouse-over, add a border with the primary color */
    &:hover input ~ .checkmark {
      border: 1px solid ${({ theme }) => theme.colors.primary};
    }

    input:focus-visible ~ .checkmark {
      box-sizing: border-box;
      line-height: 30px;
      border: 3px solid ${({ theme }) => theme.colors.secondary};
    }

    /* When the checkbox is checked, add the primary color to background */
    & input:checked ~ .checkmark {
      background-color: ${({ theme }) => theme.colors.primary};
      color: #ececec;
    }

    /* Show the checkmark when checked */
    & input:checked ~ .checkmark:after {
      display: block;
    }

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    /* Create a custom checkbox */
    .checkmark {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 104px;
      max-width: 100%;
      height: 44px;
      font-size: 1rem;
      font-weight: 700;
      border-radius: 22px;
      box-sizing: border-box;
      line-height: 44px;
      text-align: center;
      color: ${({ theme }) => theme.colors.primary};
      background-color: #ececec;
      padding: 0 22px;
      white-space: nowrap;

      border: 1px solid transparent;
    }
  }
`;

export const Title = styled.h4`
  margin-top: 2px;
  margin-bottom: 20px;
  text-align: center;

  @media only screen and (min-width: ${({ theme: { breakpoints } }) =>
      breakpoints.tablet}) {
    text-align: left;
  }
`;
